<template>
  <div style="padding: 10px 10px 10px 10px;font-size:larger;">
    <div>
      <span class="pull-right text-right" style="min-width:90px;">{{ order.subtotalCurrency }}</span>
      <span class="pull-right text-right">Item Total</span>
      <div class="clearfix"></div>
    </div>
    <div>
      <span class="pull-right text-right" style="min-width:90px;">{{ order.shipchargeCurrency }}</span>
      <span class="pull-right text-right">Shipping</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.discountShipping">
      <span class="pull-right text-right" style="min-width:90px;">-{{ order.discountShippingCurrency }}</span>
      <span class="pull-right text-right">Ship Discount</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.orderstatusID <= 1" class="text-right text-muted">
      <small><em>({{ order.shipmethod }} -  {{ order.dayrange }} business days)</em></small>
    </div>
    <div v-if="order.giftwrapcharge">
      <span class="pull-right text-right" style="min-width:90px;">{{ order.giftwrapchargeCurrency }}</span>
      <span class="pull-right text-right">Gift Box</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.discountGiftwrap">
      <span class="pull-right text-right" style="min-width:90px;">-{{ order.discountGiftwrapCurrency }}</span>
      <span class="pull-right text-right">Box Discount</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.tax">
      <span class="pull-right text-right" style="min-width:90px;">{{ order.taxCurrency }}</span>
      <span class="pull-right text-right">Tax</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.promotiondiscount">
      <span class="pull-right text-right" style="min-width:90px;">-{{ order.promotiondiscountCurrency }}</span>
      <span class="pull-right text-right">Promotion</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.giftcardamountapplied">
      <span class="pull-right text-right" style="min-width:90px;">-{{ order.giftcardamountappliedCurrency }}</span>
      <span class="pull-right text-right">Gift Card used</span>
      <div class="clearfix"></div>
    </div>
    <div v-if="order.storecreditapplied">
      <span class="pull-right text-right" style="min-width:90px;">-{{ order.storecreditappliedCurrency }}</span>
      <span class="pull-right text-right">Store Credit used</span>
      <div class="clearfix"></div>
    </div>
    <div>
      <span class="pull-right text-right" style="min-width:90px;">
          <strong>{{ order.finaltotalCurrency }}</strong>
      </span>
      <span class="pull-right text-right text-title"><strong>Total</strong></span>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>

export default {
    props: {
        order: {
            type: Object,
            default: null
        },
    },

    data () {
        return {
        }
    },

    methods: {
    },
}
</script>
